import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "热门爆料", to: "/clues" },
  { label: "主题分类", to: "/categories" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50/70 backdrop-blur"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:px-8 lg:h-[72px]">
        <Link to="/" className="flex items-center gap-2.5" aria-label="17.cc 网友爆料站 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
            17
          </span>
          <span className="leading-tight">
            <span className="block font-heading text-lg font-bold tracking-tight text-foreground-950">
              17.cc
            </span>
            <span className="block text-[11px] tracking-wide text-foreground-600">
              网友爆料站
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-800"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/submit"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            我要爆料
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="mx-auto w-full px-4 py-3" aria-label="移动端导航">
            <ul className="flex flex-col gap-1">
              {navItems.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    className={({ isActive }) =>
                      `block rounded-md px-3 py-2.5 text-sm font-medium ${
                        isActive
                          ? "bg-primary-100 text-primary-800"
                          : "text-foreground-700 hover:bg-background-100"
                      }`
                    }
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
              <li>
                <Link
                  to="/submit"
                  className="mt-1 block rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-semibold text-background-50"
                >
                  我要爆料
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </header>
  );
}